import { FunctionComponent } from "react";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { Button } from "src/components/generic";
import { TextInputWithRegister } from "src/components/inputs";
import { ToastStatus, useToast } from "src/context/ToastContext";
import { dynamo } from "src/utils";
import { userTypes } from "src/utils/types";
import { BUTTON_THEME_TYPES } from "src/utils/types/ButtonTypes";


interface IEditClientFormProps {
    client: userTypes.Client
    cancel: () => void;
}

const EditClientClientForm: FunctionComponent<IEditClientFormProps> = ({ client, cancel }) => {
    const navigate = useNavigate();
    const { setToast } = useToast();
    const {
        register,
        handleSubmit
    } = useForm({
        defaultValues: {
            name: client.userInfo.name,
            phone: client.userInfo.phone,
            dob: client.userInfo.dob,
            address: client.userInfo.address,
            city: client.userInfo.city,
            state: client.userInfo.state,
            zip: client.userInfo.zip,
        }
    });

    const save = async (data: any) => {
        try {
            client.userInfo.name = data.name
            client.userInfo.phone = data.phone
            client.userInfo.dob = data.dob
            client.userInfo.address = data.address
            client.userInfo.city = data.city
            client.userInfo.state = data.state
            client.userInfo.zip = data.zip

            const result = await dynamo.mutations.putUser(client);

            if (result.status === 201) {
                setToast({
                    message: "Client Updated",
                    status: ToastStatus.SUCCESS
                });
                navigate(0);
            }
        } catch (error: any) {
            setToast({
                message: error?.message || "Client Update Failed",
                status: ToastStatus.FAIL
            });
        }
    }

    return (
        <form>
            <TextInputWithRegister
                id="name"
                label="Name"
                placeholder={client.userInfo.name}
                register={register('name')}
            />

            <TextInputWithRegister
                id="phone"
                label="Phone"
                placeholder={client.userInfo.phone}
                register={register('phone')}
            />

            <TextInputWithRegister
                id="dob"
                label="Birthdate"
                placeholder={client.userInfo.dob}
                register={register('dob')}
            />

            <TextInputWithRegister
                id="address"
                label="Address"
                placeholder={client.userInfo.address}
                register={register('address')}
            />

            <TextInputWithRegister
                id="city"
                label="City"
                placeholder={client.userInfo.city}
                register={register('city')}
            />

            <TextInputWithRegister
                id="state"
                label="State"
                placeholder={client.userInfo.state}
                register={register('state')}
            />

            <TextInputWithRegister
                id="zip"
                label="Zip Code"
                placeholder={client.userInfo.zip}
                register={register('zip')}
            />

            <Button text="Cancel" theme={BUTTON_THEME_TYPES.PRIMARY_INVERSE} onClick={cancel} />
            <Button text="Save" theme={BUTTON_THEME_TYPES.PRIMARY_INVERSE} onClick={handleSubmit(save)} />
        </form>
    );
}

export default EditClientClientForm